import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function OverOnsTeaser() {
  return (
    <section className="py-16 bg-[#080808]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/over-ons" data-testid="over-ons-teaser"
          className="group block bg-[#111] border border-white/8 hover:border-[#C9A84C]/30 rounded-2xl p-8 transition-all duration-300 hover:shadow-[0_0_40px_rgba(201,168,76,0.06)] max-w-2xl">
          <div className="flex items-start gap-5">
            {/* Avatar */}
            <div className="w-14 h-14 rounded-2xl bg-[#C9A84C]/15 border border-[#C9A84C]/30 flex items-center justify-center shrink-0 group-hover:bg-[#C9A84C]/20 transition-colors">
              <span className="text-[#C9A84C] font-black text-xl">S</span>
            </div>

            <div className="flex-1 min-w-0">
              <p className="text-[#C9A84C] text-xs font-bold uppercase tracking-widest mb-1">Het verhaal achter FitSmith</p>
              <h2 className="text-white font-bold text-lg mb-2">Sam van Grondelle</h2>
              <p className="text-zinc-500 text-sm leading-relaxed line-clamp-2">
                Al meer dan zeven jaar actief in de sportschool. Wat ooit startte als een persoonlijke
                uitdaging, groeide uit tot een platform voor iedereen die serieus wil groeien.
              </p>
              <span className="inline-flex items-center gap-1.5 mt-4 text-[#C9A84C] text-sm font-semibold group-hover:gap-2.5 transition-all">
                Lees het volledige verhaal <ArrowRight size={14} />
              </span>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
